module.exports = __webpack_public_path__ + "img/personal.daa59625.png";